import React from 'react';
import '../assets/css/Counters.css';

function Counters() {
  const highlights = [
    {
      icon: "fas fa-lightbulb",
      title: "أفكار مبتكرة",
      description: "نقدّم حلولًا رقمية مبتكرة تُلائم كل عميل على حدة."
    },
    {
      icon: "fas fa-handshake",
      title: "علاقات طويلة الأمد",
      description: "نحرص على بناء علاقات قائمة على الثقة والمصداقية."
    },
    {
      icon: "fas fa-users-cog",
      title: "فريق متميز",
      description: "يعمل معنا فريق ذو خبرة عالية في تطوير البرمجيات."
    },
    {
      icon: "fas fa-rocket",
      title: "رحلة نجاح",
      description: "كل مشروع ننجزه هو خطوة في مسيرة نجاحنا معكم."
    },
  ];

  return (
    <section className="highlights-section">
      <div className="highlights-container">
        <h1 className="highlights-title">ما يميزنا</h1>

        <div className="highlights-grid">
          {highlights.map((item, index) => (
            <div className="highlight-card" key={index}>
              <div className="highlight-icon">
                <i className={item.icon}></i>
              </div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Counters;